<form
	[formGroup]="payTypesForm"
	class="flex flex-col md:flex-row gap-2 md:gap-4 w-full h-full"
>
	<!-- Left Panel - PTO Setting -->
	<div
		class="bg-white dark:bg-gray-700 rounded-lg shadow p-4 w-full md:w-1/2 flex-grow"
	>
		<div class="flex justify-between items-center mb-4">
			<h2 class="font-avertaBold text-gray-800 dark:text-gray-200">
				PTO Setting
			</h2>
			@if (isSavingSettings) {
				<div
					class="flex items-center text-sm text-gray-500 dark:text-gray-400"
				>
					<svg
						class="animate-spin h-4 w-4 mr-2"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
					>
						<circle
							class="opacity-25"
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							stroke-width="4"
						></circle>
						<path
							class="opacity-75"
							fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						></path>
					</svg>
					Saving...
				</div>
			}
		</div>

		<div class="grid grid-cols-1 gap-6 p-4 max-w-4xl mx-auto">
			<!-- First Row: Require Reason and Shift Impact -->
			<div class="grid grid-cols-2 gap-4">
				<!-- Require Reason Toggle -->
				<div class="flex flex-col">
					<label
						for="reasonValidation"
						class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
					>
						Require Reason
					</label>
					<div class="mt-2">
						<label  for="reasonValidation"
						 class="inline-flex items-center cursor-pointer">
							<input
								type="checkbox"
								id="reasonValidation"
								formControlName="ReasonValidation"
								class="sr-only peer"
							/>
							<div
								class="relative w-11 h-6 bg-gray-200 dark:bg-gray-600 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"
							></div>
						</label>
					</div>
				</div>

				<!-- Shift Impact Toggle -->
				<div class="flex flex-col">
					<label
						for="shiftImpact"
						class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
					>
						Shift Impact
					</label>
					<div class="mt-2">
						<label for="shiftImpact"
						 class="inline-flex items-center cursor-pointer">
							<input
								type="checkbox"
								id="shiftImpact"
								formControlName="ShiftImpact"
								class="sr-only peer"
							/>
							<div
								class="relative w-11 h-6 bg-gray-200 dark:bg-gray-600 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"
							></div>
						</label>
					</div>
				</div>
			</div>

			<!-- Second Row: FMLA Request Recipients -->
			<div class="flex flex-col">
				<label
					for="FMLARequestRecipients"
					class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
				>
					FMLA Request Recipients
				</label>
				<textarea
					id="FMLARequestRecipients"
					formControlName="FMLARequestRecipients"
					placeholder="Enter email addresses separated by commas"
					rows="2"
					style="
						resize: none;
						overflow-y: hidden;
						min-height: 40px;
						max-height: 120px;
					"
					class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500 dark:placeholder-gray-500 placeholder:text-sm dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600"
					[class.border-red-500]="hasEmailErrors()"
					[class.focus:ring-red-500]="hasEmailErrors()"
					[class.border-gray-300]="!hasEmailErrors()"
					(input)="onEmailInput($event)"
				></textarea>

				@if (hasEmailErrors()) {
					<div class="text-red-500 text-sm mt-2">
						{{ getEmailErrorMessage() }}
					</div>
				}

				<div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
					Enter email addresses separated by commas
				</div>
			</div>
		</div>
	</div>

	<!-- Right Panel - PayType Colors Mapping -->
	<div
		class="bg-white dark:bg-gray-700 rounded-lg shadow p-4 w-full md:w-1/2 flex-grow"
	>
		<div class="flex justify-between items-center mb-4">
			<h2 class="font-avertaBold text-gray-800 dark:text-gray-200">
				PayType Colors Mapping
			</h2>
			<div
				*ngIf="isUpdating"
				class="flex items-center text-sm text-gray-500 dark:text-gray-400"
			>
				<svg
					class="animate-spin h-4 w-4 mr-2"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
				>
					<circle
						class="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						stroke-width="4"
					></circle>
					<path
						class="opacity-75"
						fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					></path>
				</svg>
				Saving...
			</div>
		</div>

		<div
			*ngIf="payTypes.length > 0"
			class="space-y-3 min-h-60 h-[calc(100vh-355px)] scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll"
		>
			<!-- Dynamic payTypes from API - No checkboxes, just color pickers -->
			<div
				class="flex items-center justify-between py-3 px-3 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-600"
				*ngFor="let payType of payTypes; let i = index"
			>
				<div class="flex items-center flex-grow">
					<label for="PayType"
						class="text-sm font-medium text-gray-700 dark:text-gray-300"
					>
						{{ payType.PayType }}
					</label>
				</div>

				<!-- Color Picker Section -->
				<div class="flex items-center space-x-3">
					<div
						class="w-6 h-6 rounded-full border-2 border-gray-300 dark:border-gray-500 shadow-sm"
						[style.backgroundColor]="payType.ColorCode"
						[title]="'Current color: ' + payType.ColorCode"
					></div>
					<input
						type="color"
						[value]="payType.ColorCode"
						(change)="onColorChange(i, $event)"
						[disabled]="isUpdating"
						class="w-8 h-8 cursor-pointer rounded border border-gray-300 dark:border-gray-500 disabled:cursor-not-allowed disabled:opacity-50"
						[title]="'Change color for ' + payType.PayType"
					/>
				</div>
			</div>

			<!-- Loading state -->
			<div *ngIf="isLoading" class="py-8 text-center">
				<div class="flex items-center justify-center">
					<svg
						class="animate-spin h-8 w-8 text-gray-400"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
					>
						<circle
							class="opacity-25"
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							stroke-width="4"
						></circle>
						<path
							class="opacity-75"
							fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						></path>
					</svg>
				</div>
				<p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
					Loading pay types...
				</p>
			</div>

			<!-- Empty state -->
			<div
				*ngIf="!isLoading && payTypes.length === 0"
				class="py-8 text-center text-sm text-gray-500 dark:text-gray-400"
			>
				<p>No pay types available</p>
			</div>
		</div>
	</div>
</form>
